// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2vBDU","bigColWidth":"Table_bigColWidth__2lgMO","biggerColWidth":"Table_biggerColWidth__1J2Gn","row":"Table_row__T_gTT","col":"Table_col__1Jjnb"};